import { logsApplicationApi } from '@api/logs/logs-application.api';

export const { useLazyLoadRequestsQuery } = logsApplicationApi;
